import Dbm from "dbm";
import Website from "../../../index.js";

export default class TouchController extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("gamePlay", null);
        this.item.requireProperty("player", null);

        let pixiLayer = new PIXI.Container();
        this.item.requireProperty("pixiLayer", pixiLayer);

        let buttonWidth = 10;
        let buttonHeight = 10;
    }

    setup() {
        let pixiLayer = this.item.pixiLayer;
        let leftButton = new PIXI.Container();
        pixiLayer.addChild(leftButton);

        leftButton.position.y = 0.5*Website.game.Sizes.HEIGHT;

        {
            leftButton.eventMode = "static";
            leftButton.on("pointerdown", this._callback_leftDown.bind(this));
            leftButton.on("pointerup", this._callback_leftUp.bind(this));

            const box = new PIXI.Graphics();
            box.beginFill(0x00ff00);
            box.drawRect(0, 0, 0.5*Website.game.Sizes.WIDTH, 0.5*Website.game.Sizes.HEIGHT);
            box.endFill();
            box.alpha = 0;
            leftButton.addChild(box);

            const sprite = Website.game.getSprite("game-buttons", "jump");
            sprite.anchor.set(0, 1);

            sprite.position.x = 5;
            sprite.position.y = Website.game.Sizes.HEIGHT-5;

            pixiLayer.addChild(sprite);
        }


        let rightButton = new PIXI.Container();
        pixiLayer.addChild(rightButton);

        rightButton.position.x = 0.5*Website.game.Sizes.WIDTH;
        rightButton.position.y = 0.5*Website.game.Sizes.HEIGHT;

        {
            rightButton.eventMode = "static";
            rightButton.on("pointerdown", this._callback_rightDown.bind(this));
            rightButton.on("pointerup", this._callback_rightUp.bind(this));

            const box = new PIXI.Graphics();
            box.beginFill(0xffff00);
            box.drawRect(0, 0, 0.5*Website.game.Sizes.WIDTH, 0.5*Website.game.Sizes.HEIGHT);
            box.endFill();
            box.alpha = 0;
            rightButton.addChild(box);
            
            const sprite = Website.game.getSprite("game-buttons", "throw");
            sprite.anchor.set(1, 1);

            sprite.position.x = Website.game.Sizes.WIDTH-5;
            sprite.position.y = Website.game.Sizes.HEIGHT-5;

            pixiLayer.addChild(sprite);
        }
    }

    _callback_leftDown(aEvent) {
        //console.log("_callback_keyDown");

        this.item.player.controller.startJump();
    }

    _callback_leftUp(aEvent) {
        this.item.player.controller.jumpReleased();
    }

    _callback_rightDown(aEvent) {
        //console.log("_callback_keyDown");

        this.item.player.controller.throw();
    }

    _callback_rightUp(aEvent) {
        
    }
}